/**
 *
 * Cursor Rhomboid Shape for Feature Mouseover
 *
 */
( function( $ ) {
	var mouseX;
	var mouseY;

	/**
	 * Function to fade in the cursor
	*/
	function fadeInCursor() {
		$( '.cursor-outer' ).css( 'transform', 'translate(-100px, -65px) scale(1)' );
	}

	/**
	 * Function to fade out the cursor
	*/
	function fadeOutCursor() {+
	$( '.cursor-outer' ).css( 'transform', 'translate(-100px, -65px) scale(0)' );
	}

	// Mouse move event handler
	$( document ).mousemove( function( e ) {
		if ( 0 < $( e.target ).closest( '.feature-mouseover' ).length ) {
			mouseX = e.pageX;
			mouseY = e.pageY - $( window ).scrollTop();
			$( '.cursor-outer' ).stop().animate( { // Use stop() to prevent queuing of animations
				'left': mouseX + 'px',
				'top': mouseY + 'px'
			}, 0 ); // Adjust the delay time (in milliseconds) as needed
		} else {
			fadeOutCursor(); // If not inside .feature-mouseover, fade out cursor
		}
	} );


	// Mouse enter event handler
	$( '.feature-mouseover' ).mouseenter( function() {
		fadeInCursor();
	} );

	// Mouse leave event handler
	$( '.feature-mouseover' ).mouseleave( function() {
		fadeOutCursor();
	} );
} )( jQuery );
